import * as React from 'react';
import { NewDropdown } from '../../../components/synced/ui/NewDropdown/NewDropdown';

import { getConstantQueryFetch } from '../../../helpers/constants';
import { getPDFNoteCodeTypeIdsForProjectDocType } from '../../../helpers/mapping/PDFNoteCodeTypeVals';
import { formatPDFNoteCodeLabel } from '../../../helpers/mapping/formatPDFNoteCodeLabel';
import { PDFNoteCode } from "../../notes/models/PDFNoteCode";
import { services } from '../../../services';
import { useBackgroundPromiseWrapper } from '../../../helpers/hooks/useBackgroundPromiseWrapper';


interface NotesFiltersProps {
  codeFilterId: number;
  onCodeFilterChange: (codeId: number) => void;
  projectDocTypeId?: number;
  totalCount?: number;
}

export const NotesFilters: React.FC<NotesFiltersProps> = ({ codeFilterId, onCodeFilterChange, projectDocTypeId, totalCount }) => {
  const [promiseWrapper] = useBackgroundPromiseWrapper();

  const codeTypeIds = React.useMemo(
    () => getPDFNoteCodeTypeIdsForProjectDocType(projectDocTypeId),
    [projectDocTypeId]
  );
  const notesFiltersStorageKey = React.useMemo(
    () => `NotesFilters_${codeTypeIds.join("-")}`,
    [codeTypeIds]
  );

  const [codes, setCodes] = React.useState<any[]>([]);
  React.useEffect(() => {
    const codesStringFromStorage: string | null = sessionStorage.getItem(notesFiltersStorageKey);
    if (codesStringFromStorage != null) {
      setCodes(JSON.parse(codesStringFromStorage));
      return;
    }

    promiseWrapper(
      () => services.pDFNoteCodeService.fetch({
        ...getConstantQueryFetch(),
        CodeTypeIds: codeTypeIds,
        Sorts: [{ Field: "Id", Desc: false }]
      }),
      (res: PDFNoteCode[]) => {
        const items: any[] = [
          { label: "Все коды ошибок", value: 0 },
          ...res.map(x => ({
            label: formatPDFNoteCodeLabel(x, codeTypeIds[0]),
            value: x.Id,
          }))
        ];
        setCodes(items);
        sessionStorage.setItem(notesFiltersStorageKey, JSON.stringify(items));
      }
    );
    // eslint-disable-next-line
  }, [codeTypeIds, notesFiltersStorageKey]);

  React.useEffect(() => {
    if (codes.length <= 1 || codeFilterId <= 0) {
      return;
    }
    const validIds = new Set(
      codes.filter((c: { value: number }) => c.value !== 0).map((c: { value: number }) => c.value)
    );
    if (!validIds.has(codeFilterId)) {
      onCodeFilterChange(0);
    }
  }, [codes, codeFilterId, onCodeFilterChange]);

  return (
    <div className="notes-filter-bar">
      <NewDropdown
        value={codeFilterId}
        options={codes}
        onChange={e => onCodeFilterChange(e.value)}
        appendTo={document.body} />
      {totalCount != null && (
        <span className="notes-filter-total">Всего: <b>{totalCount}</b></span>
      )}
    </div>
  );
}
